import React, { useState } from "react";
import AdminManageOrdersPage from "../AdminManageOrdersPage/AdminManageOrdersPage";
import { Tabs, Tab, Typography, Box } from "@mui/material";
import "./AdminOrderPage.scss";
import AdminManagePaymentsPage from "../AdminManagePaymentsPage/AdminManagePaymentsPage";
import AdminDeliveriesPage from "../AdminDeliveriesPage/AdminDeliveriesPage";

const AdminOrderPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div className="admin-order-page">
      {/* Compact Header */}
      <Box sx={{ 
        background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        color: 'white',
        p: 2,
        borderRadius: 2,
        mb: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      }}>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 0.5 }}>
          📦 Orders Dashboard
        </Typography>
      </Box>

      {/* Main Content Card */}
      <Box sx={{
        background: 'white',
        borderRadius: 3,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        border: '1px solid rgba(0,0,0,0.05)'
      }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            background: '#f8fafc',
            px: 3,
            '& .MuiTabs-indicator': {
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              height: 3,
              borderRadius: '2px 2px 0 0'
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              color: '#64748b',
              '&.Mui-selected': {
                color: '#1e293b'
              }
            }
          }}
        >
          <Tab label="Manage Orders" />
          <Tab label="Manage Deliveries" />
          <Tab label="💳 Manage Payments" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <AdminManageOrdersPage />}
          {activeTab === 1 && <AdminDeliveriesPage />}
          {activeTab === 2 && <AdminManagePaymentsPage />}
        </Box>
      </Box>
    </div>
  );
};

export default AdminOrderPage;
